// extracted by mini-css-extract-plugin
export default {"wrapper":"chatbot_wrapper__Pquzl","right":"chatbot_right__GhGGj","left":"chatbot_left__0YRVz","direct_link":"chatbot_direct_link__r-2TY"};